<div class="footer-content">
  <span>Last update: {{ buildDate }}</span>
  <span>© {{ currentYear }} Chevron Corporation</span>
  <span>Company Confidential</span>
</div>
<div class="footer-contacts">
  <span>Content contact: <a [href]="mailtoLink">ETH</a></span>
  <span>Technical contact: <a [href]="mailtoLink">ETH</a></span>
</div>
